module.exports = __webpack_public_path__ + "static/renault-alpine-a110-0286b018bdf541188f7aa32488eee4f3.jpg";